import {FC} from "react";

export const Marker: FC<{
    lat: number;
    lng: number;
    children: React.ReactNode;
}> = (props) => <span>{props.children}</span>;
